import {
  keepPreviousData,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClientAccount } from '~/@api/client/useApiClientAccount'

export function useFinancialOverviewQuery() {
  const client = useApiClientAccount()
  const queryClient = useQueryClient()

  async function fetchAggregates() {
    return client.account
      .portfolioControllerGetAggregates({
        secure: true,
      })
      .then((resp) => resp.data.aggregates)
  }

  const query = useQuery({
    queryKey: ['financial-overview'],
    queryFn: fetchAggregates,
    placeholderData: keepPreviousData,
    refetchOnMount: true,
    staleTime: 0,
  })

  return {
    ...query,
    reloadAggregates: () =>
      queryClient.invalidateQueries({ queryKey: ['financial-overview'] }),
  }
}
